import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import IconButton from '@mui/material/IconButton';
import React from 'react';

import * as GQL from '~/graphql/generated/client';

interface SortButtonProps {
  sortDirection: GQL.SortDirection | null;
  onSortChange: (direction: GQL.SortDirection | null) => void;
}

const SortButton: React.FC<SortButtonProps> = ({
  sortDirection,
  onSortChange,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    const newDirection = !sortDirection
      ? GQL.SortDirection.Asc
      : sortDirection === GQL.SortDirection.Asc
        ? GQL.SortDirection.Desc
        : null;
    onSortChange(newDirection);
  };

  return (
    <IconButton onClick={handleClick} size="small" sx={{ ml: 1, mb: 1 }}>
      {sortDirection === GQL.SortDirection.Asc ? (
        <ArrowUpwardIcon fontSize="small" />
      ) : sortDirection === GQL.SortDirection.Desc ? (
        <ArrowDownwardIcon fontSize="small" />
      ) : (
        <ArrowUpwardIcon fontSize="small" sx={{ opacity: 0.3 }} />
      )}
    </IconButton>
  );
};

export default SortButton;
